import { lazy } from "react";
// Keep card mapping static, but lazy-load each implementation chunk.
// This preserves existing card IDs while reducing RCC initial JS cost.
// Monthly versions of linearity/projection cards
// These cards use monthly Time Series data and are only enabled for specific customers (e.g., C0017)
const QtdBookingsCard = lazy(() => import("./RccCards/QtdBookingsCard"));
const YtdBookingsCard = lazy(() => import("./RccCards/YtdBookingsCard"));
const QtrProjectionCard = lazy(() => import("./RccCards/QtrProjectionCard"));
const PerformanceInsightsCard = lazy(
  () => import("./RccCards/PerformanceInsightsCard")
);
const LinearityComparisonCard = lazy(
  () => import("./RccCards/LinearityComparisonCard")
);
const TeamWiseCurrentQtrProjeectionCard = lazy(
  () => import("./RccCards/TeamWiseCurrentQtrProjeectionCard")
);
const WonACVByTeamCard = lazy(() => import("./RccCards/WonACVByTeamCard"));
const WonACVByTeamMonthlyCard = lazy(() => import("./RccCards/WonACVByTeamMonthlyCard"));
const PipelineMixByTeamCard = lazy(
  () => import("./RccCards/PipelineMixByTeamCard")
);
const PipelineMixByTeamMonthlyCard = lazy(
  () => import("./RccCards/PipelineMixByTeamMonthlyCard")
);
const PipelineMixByLeadSourceCategoryCard = lazy(
  () => import("./RccCards/PipelineMixByLeadSourceCategoryCard")
);
const PipelineMixByIndustryCard = lazy(
  () => import("./RccCards/PipelineMixByIndustryCard")
);
const PipelineMixByVerticalCard = lazy(
  () => import("./RccCards/PipelineMixByVerticalCard")
);
const PipelineMixByLeadSourceCard = lazy(
  () => import("./RccCards/PipelineMixByLeadSourceCard")
);
const WonACVByLeadSourceCategoryCard = lazy(
  () => import("./RccCards/WonACVByLeadSourceCategoryCard")
);
const WonACVByIndustryCard = lazy(() => import("./RccCards/WonACVByIndustryCard"));
const WonACVByVerticalCard = lazy(() => import("./RccCards/WonACVByVerticalCard"));
const WonACVByLeadSourceCard = lazy(
  () => import("./RccCards/WonACVByLeadSourceCard")
);
const PipelineMixBySolutionCategoryCard = lazy(
  () => import("./RccCards/PipelineMixBySolutionCategoryCard")
);
const WonACVBySolutionCategoryCard = lazy(
  () => import("./RccCards/WonACVBySolutionCategoryCard")
);
const PipelineMixByDealCategoryCard = lazy(
  () => import("./RccCards/PipelineMixByDealCategoryCard")
);
const WonACVByDealCategoryCard = lazy(
  () => import("./RccCards/WonACVByDealCategoryCard")
);
const PipelineMixByProductLineCard = lazy(
  () => import("./RccCards/PipelineMixByProductLineCard")
);
const WonACVByProductLineCard = lazy(
  () => import("./RccCards/WonACVByProductLineCard")
);
const PipelineMixByCustomerTypeCard = lazy(
  () => import("./RccCards/PipelineMixByCustomerTypeCard")
);
const PipelineMixByOpportunityRecordTypeCard = lazy(
  () => import("./RccCards/PipelineMixByOpportunityRecordTypeCard")
);
const WonACVByCustomerTypeCard = lazy(
  () => import("./RccCards/WonACVByCustomerTypeCard")
);
const WonACVByOpportunityRecordTypeCard = lazy(
  () => import("./RccCards/WonACVByOpportunityRecordTypeCard")
);
const PipelineMixByCustomerSegmentCard = lazy(
  () => import("./RccCards/PipelineMixByCustomerSegmentCard")
);
const PipelineMixBySalesTypeCard = lazy(
  () => import("./RccCards/PipelineMixBySalesTypeCard")
);
const WonACVByCustomerSegmentCard = lazy(
  () => import("./RccCards/WonACVByCustomerSegmentCard")
);
const WonACVBySalesTypeCard = lazy(() => import("./RccCards/WonACVBySalesTypeCard"));
const AverageCycleTimeCard = lazy(() => import("./RccCards/AverageCycleTimeCard"));
const LostReasonTrend = lazy(() => import("./RccCards/LostReasonTrend"));
const AverageDealSizeTrend = lazy(() => import("./RccCards/AverageDealSizeTrend"));
const ShiftInValueOfOppLost = lazy(() => import("./RccCards/ShiftInValueOfOppLost"));
const WinRateTrend = lazy(() => import("./RccCards/WinRateTrend"));
const PipelineCoverage = lazy(() => import("./RccCards/PipelineCoverage"));
const NudgeCard = lazy(() => import("./RccCards/NudgeCard"));
const PullInCard = lazy(() => import("./RccCards/PullInCard"));
const MonthlyLinearityComparisonCard = lazy(
  () => import("./RccCards/MonthlyLinearityComparisonCard")
);
const TeamWiseCurrentMonthProjectionCard = lazy(
  () => import("./RccCards/TeamWiseCurrentMonthProjectionCard")
);
const FreshNewQualifiedPipelineCard = lazy(
  () => import("./RccCards/FreshNewQualifiedPipelineCard")
);
const PipelineCreatedByTeamRaid9Card = lazy(
  () => import("./RccCards/PipelineCreatedByTeamRaid9Card")
);
const PipelineCreatedByTeamRoamingDNACard = lazy(
  () => import("./RccCards/PipelineCreatedByTeamRoamingDNACard")
);
const AverageACVPerCustomerTrendCard = lazy(
  () => import("./RccCards/AverageACVPerCustomerTrendCard")
);

// Registry of all available cards: id -> Component
// Card visibility is controlled via INT_RCC_Cards_To_UI_Role_ID_Mapping database table
const cardRegistry = {
  RCC_QTD_Bookings: QtdBookingsCard,
  RCC_YTD_Bookings: YtdBookingsCard,
  RCC_Qtr_Projection: QtrProjectionCard,
  RCC_Performance_Insights: PerformanceInsightsCard,
  RCC_Linearity_Comparison: LinearityComparisonCard,
  RCC_Team_Wise_Current_Qtr_Projection: TeamWiseCurrentQtrProjeectionCard,
  RCC_Won_ACV_By_Team: WonACVByTeamCard,
  RCC_Won_ACV_By_Team_Monthly: WonACVByTeamMonthlyCard,
  RCC_Won_ACV_By_Lead_Source_Category: WonACVByLeadSourceCategoryCard,
  RCC_Won_ACV_By_Lead_Source: WonACVByLeadSourceCard,
  RCC_Won_ACV_By_Industry: WonACVByIndustryCard,
  RCC_Won_ACV_By_Vertical: WonACVByVerticalCard,
  RCC_Won_ACV_By_Customer_Type: WonACVByCustomerTypeCard,
  RCC_Won_ACV_By_Opportunity_Record_Type: WonACVByOpportunityRecordTypeCard,
  RCC_Won_ACV_By_Customer_Segment: WonACVByCustomerSegmentCard,
  RCC_Won_ACV_By_Sales_Type: WonACVBySalesTypeCard,
  RCC_Won_ACV_By_Solution_Category: WonACVBySolutionCategoryCard,
  RCC_Won_ACV_By_Deal_Category: WonACVByDealCategoryCard,
  RCC_Won_ACV_By_Product_Line: WonACVByProductLineCard,
  RCC_Pipeline_Mix_By_Team: PipelineMixByTeamCard,
  RCC_Pipeline_Mix_By_Team_Monthly: PipelineMixByTeamMonthlyCard,
  RCC_Pipeline_Mix_By_Lead_Source_Category: PipelineMixByLeadSourceCategoryCard,
  RCC_Pipeline_Mix_By_Lead_Source: PipelineMixByLeadSourceCard,
  RCC_Pipeline_Mix_By_Industry: PipelineMixByIndustryCard,
  RCC_Pipeline_Mix_By_Vertical: PipelineMixByVerticalCard,
  RCC_Pipeline_Mix_By_Customer_Type: PipelineMixByCustomerTypeCard,
  RCC_Pipeline_Mix_By_Opportunity_Record_Type:
    PipelineMixByOpportunityRecordTypeCard,
  RCC_Pipeline_Mix_By_Customer_Segment: PipelineMixByCustomerSegmentCard,
  RCC_Pipeline_Mix_By_Sales_Type: PipelineMixBySalesTypeCard,
  RCC_Pipeline_Mix_By_Solution_Category: PipelineMixBySolutionCategoryCard,
  RCC_Pipeline_Mix_By_Deal_Category: PipelineMixByDealCategoryCard,
  RCC_Pipeline_Mix_By_Product_Line: PipelineMixByProductLineCard,
  RCC_Average_Cycle_Time: AverageCycleTimeCard,
  RCC_Lost_Reason_Trend: LostReasonTrend,
  RCC_Average_Deal_Size_Trend: AverageDealSizeTrend,
  RCC_Average_ACV_Per_Customer_Trend: AverageACVPerCustomerTrendCard,
  RCC_Shift_In_Value_Of_Opp_Lost: ShiftInValueOfOppLost,
  RCC_Win_Rate_Trend: WinRateTrend,
  RCC_Pipeline_Coverage: PipelineCoverage,
  RCC_Nudge: NudgeCard,
  RCC_Pull_In: PullInCard,
  RCC_Monthly_Linearity_Comparison: MonthlyLinearityComparisonCard,
  RCC_Team_Wise_Current_Month_Projection: TeamWiseCurrentMonthProjectionCard,
  RCC_Fresh_New_Qualified_Pipeline: FreshNewQualifiedPipelineCard,
  RCC_Pipeline_Created_By_Team_Raid_9: PipelineCreatedByTeamRaid9Card,
  RCC_Pipeline_Created_By_Team_Roaming_DNA: PipelineCreatedByTeamRoamingDNACard,
};

/**
 * Get card component by ID
 * @param {string} cardId - The ID of the card to retrieve
 * @returns {React.Component|null} Card component or null if not found
 */
export function getCard(cardId) {
  return cardRegistry[cardId] || null;
}

/**
 * Get all registered card IDs
 * @returns {Array} Array of card IDs
 */
export function getAllCardIds() {
  return Object.keys(cardRegistry);
}

export default cardRegistry;
